import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActionArea from "@material-ui/core/CardActionArea";
import Typography from "@material-ui/core/Typography";
import { red } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation, Trans } from "react-i18next";
// import $ from "jquery";
import axios from "axios";

import CustomToaster from "./CustomToaster";
import AddToListButton from "./AddToListButton";
import CustomAddButton from "./CustomAddButton";

const styles = (theme) => ({
  root: {
    maxWidth: 345,
    margin: "5px",
  },
  cover: {
    width: 175,
    height: 175,
    "object-fit": "contain",
    margin: "auto",
  },
  name: {
    height: 100,
    overflow: "hidden",
    marginBottom: "10px",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
  center: {
    margin: "0 auto",
  },
  ribbonZIndex: {
    "z-index": 0,
  },
  cust: {
    paddingTop: "7px",
  },
});

class CardProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertType: "",
      headContent: "",
      selectProductId: null,
      data: this.props.data,
      lang: this.props.lang,
      tariff: this.props.tariff,
      logged: this.props.logged,
      express: this.props.express,
      client_country_id: this.props.client_country_id,
      cart_products: this.props.cart_products,
      cart_product_ids: JSON.parse(this.props.cart_products.product_ids),
      fav_products: this.props.fav_products,
      fev_product_ids: JSON.parse(this.props.fav_products.fev_product_ids),
      jwt: this.props.jwt,
      api_origin: this.props.api_origin,
      api_url: this.props.api_url,
      sa: this.props.sa,
      isFev: false,
      stocks: this.props.stocks,
      sendAddEvent: this.props.sendAddEvent || false,
      elementId: this.props.elementId,
      selectedProduct: {},
      customFilterManufacturer: this.props.customFilterManufacturer || [],
      customFilterManufacturerIds: this.props.customFilterManufacturerIds || []
    };

    this.addToFav = this.addToFav.bind(this);
    this.goToExpress = this.goToExpress.bind(this);
    this.removeIdFromArr = this.removeIdFromArr.bind(this);
    this.addIdFromArr = this.addIdFromArr.bind(this);
    this.sentEventData = this.sentEventData.bind(this);
    this.manufacturerFilter = this.manufacturerFilter.bind(this);
  }

  sentEventData = (eventType, eventPayload) => {
    var event = new CustomEvent(eventType, {
      detail: eventPayload,
    });
    document.getElementById(this.state.elementId).dispatchEvent(event);
    window.dispatchEvent(event);
  };

  goToExpress = () => {
    let newurl =
      window.location.protocol + "//" + window.location.host + "/" + "cart.php";
    window.location.href = newurl;
  };

  //remove all characters except a-z0-9 
  manufacturerFilter= (manufacturer) => {
    let filtered = manufacturer.replace(/[^a-z0-9]/gi, '');   
    // return filtered replacing characters to lowercase    
    return filtered.toLowerCase(); 
  }
      
    componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data) {
      this.setState({
        data: this.props?.data,
      });
    }
    if (this.props.stocks !== prevProps.stocks) {
      this.setState({
        stocks: this.props?.stocks,
      });
    }
    if (this.props.cart_products !== prevProps.cart_products) {
      this.setState({
        cart_products: this.props.cart_products,
        cart_product_ids: JSON.parse(this.props?.cart_products?.product_ids),
      });
    }
  }

  getStockData = async (products) => {
    if (this.state.logged) {
      if (products.length > 0) {
        // Cancelar la solicitud anterior si existe
        if (this.source) {
          this.source.cancel();
        }

        this.source = axios.CancelToken.source();

        let newURL =
          this.state.api_url + "/product-inventories?select=product_id,stock";
        const stockProducts = await axios
          .get(newURL, {
            headers: {
              "Content-type": "application/json",
              Authorization: this.state.jwt,
            },
            data: JSON.stringify(products),
            method: "GET",
            cancelToken: this.source.token, // Pasar el token de cancelación a la configuración de la solicitud
          })
          .catch(function (thrown) {
            if (axios.isCancel(thrown)) {
              console.log("Request canceled", thrown.message);
            } else {
              console.log("cancel error");
            }
          });

        if (stockProducts && stockProducts?.data && stockProducts.data?.data) {
          this.setState({ stocks: [...stockProducts.data.data] });
        }
      }
    }
  };

  productHandler = async (id, manufacturer_id) => {
    let quantity = 1;
    const cartP = [...this.state.cart_product_ids, id];
    this.setState({ cart_product_ids: cartP });
    this.state.cart_products.prods_q[id] = "1";

    const data = JSON.stringify({
      product_id: id,
      quantity: quantity,
    });

    let addPrdDetls = null;
    try {
      addPrdDetls = await WebuserCartApi.create({
        product_id: id,
        quantity: quantity,
      });
    } catch (error) {}

    /*let addPrdDetls = await axios.post(this.state.api_url+`/carts`, data,
    {   
      headers: {
          "Accept": "application/json, text/javascript, * /*; q=0.01",
          "Authorization": this.state.jwt
        }
      }
    );
    */

    this.setState({ alertType: "add" });
    this.setState({ headContent: "Product added" });

    if (addPrdDetls) {
      var event = new CustomEvent("updatePHPCart", {
        detail: {
          product_id: this.state.data.id.raw,
        },
      });

      window.dispatchEvent(event);

      this.setState({
        selectProductId: id,
      });

      setTimeout(() => {
        this.setState({
          selectProductId: null,
        });
      }, 3000);
    }
  };

  removeIdFromArr(id) {
    let arr = [];
    const old_ids = this.state.cart_product_ids;
    old_ids.map((val) => {
      if (val != id) {
        arr.push(val);
      }
    });

    this.setState({ cart_product_ids: arr });
  }

  addIdFromArr(id) {
    let arr = [];

    const old_ids = [...this.state.cart_product_ids];

    if (old_ids.indexOf(id) === -1) {
      old_ids.push(id);
    }
    this.setState({ cart_product_ids: old_ids });
  }

  addToFav = async (e, stat) => {
    let p_id = this.state.data?.id?.raw;
    let product_id = { product_id: p_id };

    if (stat) {
      // const fevorite_ids = JSON.parse(this.state.fev_product_ids);
      // fevorite_ids.push(p_id);
      // this.setState({fev_product_ids: fevorite_ids});

      this.setState({ alertType: "fev" });
      this.setState({ headContent: "Product added to favorite list" });

      const fevP = [...this.state.fev_product_ids, p_id];
      this.setState({ fev_product_ids: fevP });

      console.log('add to fav:', this.state?.fev_product_ids, fevP);
      let addFevStat;
      try {
        addFevStat = await axios.post(
          this.state.api_url + `/webusers/favorites`,
          product_id,
          {
            headers: {
              Accept: "application/json, text/javascript, */*; q=0.01",
              Authorization: this.state.jwt,
            },
          }
        );
        console.log('addFevStat:', addFevStat);

        if (addFevStat) {
          this.setState({
            selectProductId: p_id,
          });
          console.log("this.state.selectProductId::", this.state.selectProductId);
          setTimeout(() => {
            this.setState({
              selectProductId: null,
            });
          }, 3000);
          //alert("Fev Product added");
        }
      } catch (error) {
        console.error('Error adding to favorites:', error);
        // Handle error if needed
      }
    } else {
      let arr = [];
      const old_fav_ids = this.state.fev_product_ids;
      old_fav_ids.map((val) => {
        if (val != p_id) {
          arr.push(val);
        }
      });

      this.setState({ fev_product_ids: arr });

      this.setState({ alertType: "fev" });
      this.setState({ headContent: "Product removed from favorite list" });

      // const old_ids = JSON.parse(this.state.fev_product_ids);
      /*const old_ids = this.state.fev_product_ids;
      const newFevIds = old_ids.filter((cids) => cids !== p_id);
      this.setState({fev_product_ids: newFevIds});*/

      let rmvFevStat = await axios.delete(
        this.state.api_url + `/webusers/favorites/${p_id}`,
        {
          headers: {
            Accept: "application/json, text/javascript, */*; q=0.01",
            Authorization: this.state.jwt,
          },
        }
      );

      if (rmvFevStat) {
        this.setState({
          selectProductId: p_id,
        });

        setTimeout(() => {
          this.setState({
            selectProductId: null,
          });
        }, 3000);
        // alert("Fev Product removed");
      }
    }
  };

  /**
   * Add to cart Event
   * @param {product} product
   */
  onProductAddedToCart = (product) => {
    console.log("Product Added to cart:", product);
  };

  /**
   * Cart qty change Event
   * @param {product}
   */
  onProductQtyModifiedOnCart = (product) => {
    console.log("product qty changed: ", product);
  };

  // Cart product delete Event
  onProductDeletedFromCart = (product) => {
    console.log("product deleted from cart", product);
  };

  // Product Add to List Event
  onProductAddedToList = (product) => {
    console.log("added to list", product);
  };

  handleProductSelected = (product) => {
    console.log(product);
    this.setState({ selectedProduct: product });
  };
  render() {
    const {
      data,
      lang,
      logged,
      express,
      tariff,
      selectProductId,
      client_country_id,
      cart_products,
      jwt,
      sa,
      api_origin,
      api_url,
      stocks,
      sendAddEvent,
      customFilterManufacturer,
      customFilterManufacturerIds
    } = this.state;
    const { classes } = this.props;

    let producto = stocks
      ? stocks.find((producto) => producto.product_id === parseInt(data.id.raw))
      : null;
    let stock = producto ? producto.stock : 0;
    let net = producto ? producto.net : 0;
    let pg = producto && producto.pg ? producto.pg.split('_')[1] || "" : "";
    let pvp = producto ? producto.price : 0;
    let in_offer = producto ? producto.in_offer : false;
    let in_offer_until = producto ? producto.in_offer_until : '0000-00-00';
    let restricted_manufacturer_ids = customFilterManufacturerIds; // IDs of restricted manufacturers
    console.log("Restricted manufacturers in this country:"+restricted_manufacturer_ids);
    console.log("Customer country:"+client_country_id);
    return (
      <>
        <Card
          className={classes.root + (data.highlight ? " card-highlight" : "")}
        >
          <CardActionArea
            className={
              classes.root +
              (data?.common?.raw.includes("specialoffer")
                ? " specialoffer"
                : data?.common?.raw.includes("blackfriday")
                ? " blackfriday"
                : data?.common?.raw.includes("anniversary")
                ? " anniversary"
                : data?.common?.raw.includes("stockclearance")                
                ? " stockclearance"
                : data?.common?.raw.includes("promotion")
                ? " promotion"
                : "")
            }
          >
            {logged ? (
              <div className="product-top-action-fev-btn ">
                <Typography className="top-like-icon">
                  {this.state.fev_product_ids.includes(data.id.raw) ? (
                    <img
                      src="../../newDesigning/images/heart-icon.svg"
                      alt="likeBtn"
                      onClick={(e) => this.addToFav(e, false)}
                      className="likeBtn"
                      loading="lazy"
                    />
                  ) : (
                    <img
                      src="../../newDesigning/images/wishlist-gray.svg"
                      alt="likeBtn"
                      onClick={(e) => this.addToFav(e, true)}
                      className="likeBtn"
                      loading="lazy"
                    />
                  )}
                </Typography>
              </div>
            ) : (
              <div></div>
            )}
            <div className="product-top-action ">
              <Typography className="top-icon" component="span">
                {
                  /*TESTdata?.in_showroom?.raw == "true" &&*/
                  data?.common?.raw.includes("supportplus") && (
                    <img
                      src="/img/svgs/headphone.svg"
                      alt="headphone"
                      loading="lazy"
                    />
                  )
                }
              </Typography>
              {/* <Typography className="top-icon" component="span">
                <img src="/img/svgs/wishlist.svg" alt="wishlist" />
              </Typography> */}

              {
                /*IN SPECIAL OFFER*/
                data?.common?.raw.includes("specialoffer") &&
                  data?.common?.raw.includes("inoffer") && (
                    <Typography
                      className="btn btn-special specialoffer"
                      variant="subtitle1"
                      component="span"
                    >
                      <Trans>SPECIAL OFFER</Trans>
                    </Typography>
                  )
              }
              {
                /*IN PROMOTION*/
                data?.common?.raw.includes("promotion") &&
                  data?.common?.raw.includes("inoffer") && (
                    <Typography
                      className="btn btn-special promotion"
                      variant="subtitle1"
                      component="span"
                    >
                      <Trans>PROMOTION</Trans>
                    </Typography>
                  )
              }
              {
                /*BLACKFRIDAY OFFER*/
                data?.common?.raw.includes("blackfriday") &&
                  data?.common?.raw.includes("inoffer") && (
                    <Typography
                      className="btn btn-special blackfriday"
                      variant="subtitle1"
                      component="span"
                    >
                      <Trans>BLACK FRIDAY</Trans>
                    </Typography>
                  )
              }
              {
                /*ANNIVARSARY OFFER*/
                data?.common?.raw.includes("anniversary") &&
                  data?.common?.raw.includes("inoffer") && (
                    <Typography
                      className="btn btn-special anniversary"
                      variant="subtitle1"
                      component="span"
                    >
                      <Trans>ANNIVERSARY OFFER</Trans>
                    </Typography>
                  )
              }
              {
                /*STOCK CLEARANCE OFFER*/
                data?.common?.raw.includes("stockclearance") &&
                  data?.common?.raw.includes("inoffer") && (
                    <Typography
                      className="btn btn-special stockclearance"
                      variant="subtitle1"
                      component="span"
                    >
                      <Trans>STOCK CLEARANCE</Trans>
                    </Typography>
                  )
              }
              {
                /*IN OFFER*/
                !data?.common?.raw.includes("blackfriday") &&
                  !data?.common?.raw.includes("anniversary") &&
                  !data?.common?.raw.includes("specialoffer") &&
                  !data?.common?.raw.includes("stockclearance") &&
                  !data?.common?.raw.includes("promotion") &&
                  data?.common?.raw.includes("inoffer") && (
                    <Typography
                      className="btn offer-btn"
                      variant="subtitle1"
                      component="span"
                    >
                      <Trans>OFFER</Trans>
                    </Typography>
                  )
              }

              {data?.not_discontinued?.raw == "false" && (
                <Typography
                  className="btn discontinued-btn"
                  variant="subtitle1"
                  component="span"
                >
                  <Trans>Discontinued</Trans>
                </Typography>
              )}
            </div>

            <div className={"card-product-img"}>
              <a
                href={"/producto.php?cod_producto=" + data.id.raw}
                className="card-product-link"
              >
                {JSON.parse(data.product_data.raw).photo != "" ? (
                  <img
                    className={`${classes.cover} product-img`}
                    src={'/common/fotos/'+this.manufacturerFilter(data.manufacturer.raw)+'/'+this.manufacturerFilter(data.ref1.raw)+'.jpg'}
                    alt={
                      data.autonames?.raw != "" && data.autonames?.raw != null
                        ? JSON.parse(data.autonames.raw)[this.state.lang]
                        : JSON.parse(data.product_data.raw).names[this.state.lang]
                    }
                    loading="lazy"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/common/fotos/default.png";
                    }}
                  />
                ) : (
                  <CardMedia
                    className={`${classes.cover} product-img`}
                    image="/common/fotos/default.png"
                    component="img"
                  />
                )}
              </a>
            </div>

            <CardContent
              className={
                "info-wrapper " +
                (data?.common?.raw.includes("specialoffer")
                  ? "specialoffer"
                  : data?.common?.raw.includes("blackfriday")
                  ? "blackfriday"
                  : data?.common?.raw.includes("anniversary")
                  ? "anniversary"
                  : data?.common?.raw.includes("stockclearance")
                  ? "stockclearance"
                  : data?.common?.raw.includes("promotion")
                  ? "promotion"
                  : data.highlight
                  ? "info-wrapper-highlight"
                  : "")
              }
            >
              <div className={"info-wrap " + classes.name}>
                <div className="score-data">{data._meta.score}</div>
                <Typography
                  className="product-name"
                  variant="subtitle1"
                  component="a"
                  href={"/producto.php?cod_producto=" + data.id.raw}
                  title={
                    data.autonames?.raw != "" && data.autonames?.raw != null
                      ? JSON.parse(data.autonames.raw)[this.state.lang]
                      : JSON.parse(data.product_data.raw).names[this.state.lang]
                  }
                >
                  {data.autonames?.raw != "" && data.autonames?.raw != null
                    ? JSON.parse(data.autonames.raw)[this.state.lang]
                    : JSON.parse(data.product_data.raw).names[this.state.lang]}
                </Typography>
              </div>

              <div className="separator-padding">
                <div className="separator-item"></div>
              </div>

              <div className="rating-wrap">
                <Typography variant="body2" component="p" className="code-txt">
                  <Trans>Code</Trans>: {data.webcode.raw} ·{" "}
                  <Trans>{data?.manufacturer?.raw}</Trans>
                </Typography>
                <Typography
                  variant="body2"
                  component="p"
                  className={
                    "ref-txt " + (data.highlight ? "ref1-highlight" : "")
                  }
                >
                  <Trans>Ref</Trans>.: {data.ref1.raw}{" "}
                </Typography>
                {!data.highlight ? (
                  <div className="separator-padding">
                    <div className="separator-item"></div>
                  </div>
                ) : (
                  <div className="separator-item"></div>
                )}
                <div className="offer-valid-block">
                  {
                  restricted_manufacturer_ids.includes(JSON.parse(data.product_data.raw).manufacturer_id)  ? (
                    <>
                      <Typography
                        variant="body2"
                        component="p"
                        className="pvp-txt"
                      >
                        <Trans>
                          Product not available for your area. Contact a local
                          distributor.
                        </Trans>
                      </Typography>
                    </>
                  ) : logged ? (
                    express ? (
                      <Typography
                        variant="body2"
                        component="p"
                        className="pvp-txt pvp-unstock"
                      >
                        <Trans>List price</Trans>:{" "}
                        {pvp < 0.01
                          ? "* Request price"
                          : pvp.toFixed(2)}{" "}
                        € 
                      </Typography>
                    ) : (
                      <Typography
                        variant="body2"
                        component="p"
                        className="offer-txt"
                      >
                        <Trans>List price</Trans>:{" "}
                        {pvp < 0.01
                          ? "* Request price"
                          : pvp.toFixed(2)}{" "}
                        €
                      </Typography>
                    )
                  ) : (
                    <Typography
                      variant="body2"
                      component="p"
                      className="pvp-txt"
                    >
                      <Trans>List price</Trans>:{" "}
                      <a
                        href="#"
                        data-popup="setting-popup2"
                        className="login_txt popup-link"
                      >
                        <Trans>You must be logged in</Trans>
                      </a>
                    </Typography>
                  )}

                  {restricted_manufacturer_ids.includes(JSON.parse(data.product_data.raw).manufacturer_id) && (
                    <></>
                  ) || (
                        <div className="offer-valid-info">
                          {logged ? (
                            express ? (
                              <Typography
                                variant="body2"
                                component="span"
                                className="offer-txt"
                              >
                                {data?.common?.raw.includes("inoffer") ? (
                                  <div>
                                    <Trans>Offer</Trans>:&nbsp;
                                    <Typography
                                      variant="body2"
                                      component="span"
                                      className="offer-price"
                                    >
                                      {net < 0.01 ? (
                                        <Trans>* Request price</Trans>
                                      ) : (
                                        net.toFixed(2)
                                      )}{" "}
                                      € - { pg }
                                    </Typography>
                                                                
                                  </div>
                                ) : 
                                  restricted_manufacturer_ids.includes(JSON.parse(data.product_data.raw).manufacturer_id) ? (
                                  <></>
                                ) : (
                                  <div>
                                    <Trans>NetPrice</Trans>:&nbsp;
                                    <Typography
                                      variant="body2"
                                      component="span"
                                      className="offer-price"
                                    >
                                      {net < 0.01 ? (
                                        <Trans>* Request price</Trans>
                                      ) : (
                                        net.toFixed(2)
                                      )}{" "}
                                      €
                                      - { pg }
                                    </Typography>
                                  </div>
                                )}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body2"
                                component="span"
                                className="pvp-txt"
                              >
                                {data?.common?.raw.includes("inoffer") ? (
                                  <div>
                                    <Trans>Offer</Trans>:&nbsp;
                                    <Typography
                                      variant="body2"
                                      component="span"
                                      className="pvp-txt"
                                    >
                                      <Trans>* Request price</Trans> €
                                    </Typography>
                                  </div>
                                ) : (
                                  <div>
                                    <Trans>NetPrice</Trans>:&nbsp;
                                    <Typography
                                      variant="body2"
                                      component="span"
                                      className="pvp-txt"
                                    >
                                      <Trans>* Request price</Trans> €
                                    </Typography>
                                  </div>
                                )}
                              </Typography>
                            )
                          ) : (
                            // <Button size="large" className="login-btn">
                            <span></span>
                            /*<div className="login-btn">
                                <a href="#" data-toggle="modal" data-target="#userModal"><strong><Trans>You must be logged in</Trans></strong></a>
                            </div>*/
                            // </Button>
                          )}
                          {logged &&
                            in_offer && (
                              <Typography
                                      variant="body2"
                                      component="span"
                                      className="date-txt"
                                    >
                                      <Trans>VALID_UNTIL</Trans>: {in_offer_until}
                              </Typography>                         
                            )}
                        </div>)}
                </div>
                {logged && !restricted_manufacturer_ids.includes(JSON.parse(data.product_data.raw).manufacturer_id) && (
                  <div className="separator-padding">
                    <div className="separator-item"></div>
                  </div>
                )}
                {logged && !restricted_manufacturer_ids.includes(JSON.parse(data.product_data.raw).manufacturer_id) && (
                  <div className="bottom-info">
                    {stock <= 0 ? (
                      <div className="progress-wrapper">
                        <div className="progress-title">
                          <Trans>On request to manufacturer</Trans>
                        </div>
                        <div className="progressbar">
                          <div
                            className="progressbar-inner"
                            style={{ width: "2%" }}
                          ></div>
                        </div>
                      </div>
                    ) : stock < 10 ? (
                      <div className="progress-wrapper progress-low">
                        <div className="progress-title">
                          <Trans>Leftunits1</Trans> {stock}{" "}
                          <Trans>Leftunits2</Trans>
                        </div>
                        <div className="progressbar">
                          <div
                            className="progressbar-inner"
                            style={{ width: (stock * 100) / 50 + `%` }}
                          ></div>
                        </div>
                      </div>
                    ) : stock >= 10 && stock < 50 ? (
                      <div className="progress-wrapper progress-medium">
                        <div className="progress-title">
                          <Trans>Leftunits1</Trans> {stock}{" "}
                          <Trans>Leftunits2</Trans>
                        </div>
                        <div className="progressbar">
                          <div
                            className="progressbar-inner"
                            style={{ width: (stock * 100) / 50 + `%` }}
                          ></div>
                        </div>
                      </div>
                    ) : (
                      stock >= 50 && (
                        <div className="progress-wrapper progress-full">
                          <div className="progress-title">
                            <Trans>Leftunits1</Trans> {stock}{" "}
                            <Trans>Leftunits2</Trans>
                          </div>
                          <div className="progressbar">
                            <div
                              className="progressbar-inner"
                              style={{ width: `100%` }}
                            ></div>
                          </div>
                        </div>
                      )
                    )}

                    {data?.not_discontinued?.raw == "false" ? (
                      <Typography
                        className="btn graybg-btn"
                        component="a"
                        href={"/producto.php?cod_producto=" + data.id.raw}
                      >
                        <Trans>Watch</Trans>
                      </Typography>
                    ) : restricted_manufacturer_ids.includes(JSON.parse(data.product_data.raw).manufacturer_id)  ? (
                      <></>
                    ) : (
                      <>
                        <ul className="cardBtn">
                          {JSON.stringify(this.state.cart_product_ids).includes(
                            data.id.raw
                          ) ? (
                            <CustomAddButton
                              data={data}
                              jwt={jwt}
                              api_url={api_url}
                              api_origin={api_origin}
                              cart_prods={this.state.cart_products.prods_q}
                              removeIdFromArr={this.removeIdFromArr}
                              addIdFromArr={this.addIdFromArr}
                              client_country_id={client_country_id}
                            />
                          ) : sendAddEvent ? (
                            <Typography
                              className={
                                "btn bluebg-btn addCarro toast-link " +
                                (this.state.sa ? "cust" : "")
                              }
                              component="a"
                              onMouseDown={(event) => {
                                event.preventDefault();
                                this.sentEventData("AddProductEvent", {
                                  product_id: data.id.raw,
                                  quantity: 1,
                                });
                              }}
                              data-toast={`toast-${data.id.raw}`}
                              data-producto={data.id.raw}
                              data-value1={
                                JSON.parse(data.product_data.raw)
                                  .manufacturer_id
                              }
                              data-value2={client_country_id}
                            >
                              <Trans>Add to</Trans>
                            </Typography>
                          ) : (
                            <Typography
                              className={
                                "btn bluebg-btn addCarro toast-link " +
                                (this.state.sa ? "cust" : "")
                              }
                              component="a"
                              onClick={(event) => {
                                event.preventDefault();
                                this.productHandler(
                                  data.id.raw,
                                  JSON.parse(data.product_data.raw)
                                    .manufacturer_id
                                );
                              }}
                              data-toast={`toast-${data.id.raw}`}
                              data-producto={data.id.raw}
                              data-value1={
                                JSON.parse(data.product_data.raw)
                                  .manufacturer_id
                              }
                              data-value2={client_country_id}
                            >
                              <Trans>Add to</Trans>
                            </Typography>
                          )}
                          {!sendAddEvent ? (
                            <AddToListButton
                              jwt={jwt}
                              data={data}
                              api_origin={api_origin}
                              api_url={api_url}
                            />
                          ) : (
                            <></>
                          )}
                        </ul>
                      </>
                    )}
                  </div>
                )}
              </div>
            </CardContent>
          </CardActionArea>
        </Card>

        {selectProductId ? (
          <CustomToaster
            data={this.state.data}
            alertType={this.state.alertType}
            headContent={this.state.headContent}
            sId={data.id.raw}
            listId={false}
            lang={this.state.lang}
          />
        ) : (
          ""
        )}
      </>
    );
  }
}

CardProduct.defaultProps = {
  custom: false,
};

export default withStyles(styles)(withTranslation()(CardProduct));
